<section class="row">
  <div class="client">
    <i class="client-icon square-icon fa-duotone fa-solid fa-building-user"></i>

    <div class="client-info">
      <div class="d-flex">
        <span class="client-name">{{ tenant.clientName }}</span>
        <span class="client-description">{{ tenant.clientDescription }}</span>
      </div>

      <span class="tenant-id" [oaiboxCopy]="tenant.id">{{ tenant.id }}</span>
    </div>
  </div>

  <div class="license-info">
    <button
      type="button"
      class="btn edit-btn"
      [oaiboxBsPopover]="edit"
      placement="left"
      trigger="click"
      container="body"
    >
      <i class="fa-solid fa-pen-to-square warning"></i>
    </button>

    <div class="license-property">
      <span class="fw-bold">Status</span>
      <div>
        @if (tenant.license && tenant.license.status) {
          License is
          <span
            class="license-status {{
              LICENSE_STATUS_CONFIG[tenant.license.status].color
            }}"
          >
            {{ LICENSE_STATUS_CONFIG[tenant.license.status].label }}
          </span>
        } @else {
          --
        }
      </div>
    </div>

    <div class="license-property">
      <span class="fw-bold">Start Date</span>
      @if (tenant.license?.startTimestamp) {
        {{ tenant.license?.startTimestamp | epochToDate | date: "yyyy-MM-dd" }}
      } @else {
        --
      }
    </div>

    <div class="license-property">
      <span class="fw-bold">End Date</span>
      @if (tenant.license?.endTimestamp) {
        {{ tenant.license?.endTimestamp | epochToDate | date: "yyyy-MM-dd" }}
        {{
          "(" +
            (tenant.license?.endTimestamp | daysRemaining) +
            " days remaining)"
        }}
      } @else {
        --
      }
    </div>
  </div>
</section>

<ng-template #edit>
  @if (updateLicenseForm) {
    <form [formGroup]="updateLicenseForm" (ngSubmit)="saveConfiguration()">
      <div class="d-flex flex-column g-g">
        <div class="d-flex g-g">
          <div>
            <label class="form-label">Start Date</label>
            <input
              type="date"
              class="form-control"
              [formControl]="updateLicenseForm.controls.startDate"
            />
          </div>
          <div>
            <label class="form-label">End Date</label>
            <input
              type="date"
              class="form-control"
              [formControl]="updateLicenseForm.controls.endDate"
            />
          </div>
        </div>

        <div class="flex-fill d-flex justify-content-between g-g">
          <div class="dropdown">
            <label class="form-label">Status</label>
            <button
              type="button"
              class="form-control dropdown-toggle"
              data-bs-toggle="dropdown"
            >
              {{ updateLicenseForm.value.status ?? "Select status" }}
            </button>
            <ul class="dropdown-menu w-100">
              @for (licenseStatus of AVAILABLE_LICENSE_STATUS; track $index) {
                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    [class.selected]="
                      updateLicenseForm.value.status === licenseStatus
                    "
                    (click)="onSelectLicenseStatus(licenseStatus)"
                  >
                    {{ licenseStatus }}
                  </button>
                </li>
              }
            </ul>
          </div>

          <button type="submit" class="btn btn-success">Save</button>
        </div>
      </div>
    </form>
  }
</ng-template>
